import { createApp } from 'vue';
import KarmicD1PTable from '../../karmic-report/D1PTable.vue'

const appElements = document.querySelectorAll('.vue-karmic-render-d1')

Array.from(appElements).forEach(element => {
  createApp(KarmicD1PTable).mount(element);
});